import React, { useState } from 'react';
import { AskRequestStatus } from '@hone-automation/common';
import { MobileSlideUpPanel } from 'presentation/components/Mobile/MobileSlideUpPanel/MobileSlideUpPanel';
import { IconCheck, IconClose } from 'components/Icons';
import { useRecategorize } from 'hooks/useRecategorize';
import { ChartOfAccountsSelect } from 'presentation/pages/bookkeeper/components/BookkeeperAccrualsSettingsForm';
import './Panels.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  txId: string;
  locationId: string;
  activeTab: AskRequestStatus;
  titleIcon?: React.ReactNode;
};

const MobileRecategorizePanel: React.FC<Props> = ({ isOpen, onClose, txId, locationId, activeTab, titleIcon }) => {
  const [comment, setComment] = useState<string>('');
  const [account, setAccount] = useState<string>('');
  const { isPending, recategorize } = useRecategorize(txId, locationId, activeTab);

  const handleCOASelect = (value: { value: string; label: string }) => {
    setAccount(value.value);
  };

  const handleSubmit = () => {
    recategorize({ comment, account });
    // Reset form
    setComment('');
    setAccount('');
    onClose();
  };

  const handleCancel = () => {
    // Reset form
    setComment('');
    setAccount('');
    onClose();
  };

  return (
    <MobileSlideUpPanel
      isOpen={isOpen}
      onClose={handleCancel}
      title="Recategorize Transaction"
      titleIcon={titleIcon}
      showExplicitCloseButton={false}
    >
      <div className="mobile-form-panel">
        <div className="form-group">
          <label>Select a new GL category</label>
          <ChartOfAccountsSelect selected={account} onChange={handleCOASelect} />
        </div>
        <div className="form-group">
          <label>Comment</label>
          <textarea
            value={comment}
            onChange={e => setComment(e.target.value)}
            placeholder="Specify the reason for changing the category."
            rows={3}
            className="form-textarea"
          />
        </div>
        <div className="form-actions">
          <button className="form-button cancel-button" onClick={handleCancel} disabled={isPending}>
            Cancel
          </button>
          <button className="form-button submit-button" onClick={handleSubmit} disabled={!account || isPending}>
            {isPending ? (
              <>
                Loading... <i className="fa fa-circle-o-notch fa-spin" />
              </>
            ) : (
              <>Recategorize</>
            )}
          </button>
        </div>
      </div>
    </MobileSlideUpPanel>
  );
};

export default MobileRecategorizePanel;
